import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Spinner, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { SectionCard } from '../SectionCard/SectionCard';
import { ContactItemOld } from './ContactItemOld';
import styles from './ContactsCardOld.module.scss';
import { useContactsCardOld } from './hooks/useContactsCardOld';
export const GetContactsCardOldTID = (parentTestId)=>getTestIds(parentTestId);
export function ContactsCardOld(param) {
    let { clientId, isArchived } = param;
    const { ContactsCardOldTestIds: TID } = useMemo(()=>GetContactsCardOldTID(), []);
    const { t: contactsTexts } = useLocaleKeys('pages.clientDetail.summary.contacts');
    const { contacts, models, isLoading, isError, onAddContact, onEditContact, onDeleteContact } = useContactsCardOld(clientId, isArchived);
    const content = (()=>{
        if (isLoading) return /*#__PURE__*/ _jsx(Spinner, {
            testId: TID.Loading()
        });
        if (isError) return /*#__PURE__*/ _jsx(Typography, {
            testId: TID.Error(),
            skin: "error",
            children: contactsTexts.loadError()
        });
        if (contacts.length === 0) return /*#__PURE__*/ _jsx(Typography, {
            testId: TID.Empty(),
            variant: "paragraph2",
            weight: "light",
            skin: "disabled",
            children: contactsTexts.emptyMessage()
        });
        return /*#__PURE__*/ _jsx(Column, {
            testId: TID.ContactsList(),
            gap: 16,
            children: contacts.map((contact)=>{
                const contactModel = models.find((model)=>model.id() === contact.id);
                if (contactModel == null) return null;
                return /*#__PURE__*/ _jsx(ContactItemOld, {
                    contact: contact,
                    contactModel: contactModel,
                    testId: TID.ContactRow(contact.id),
                    isArchived: isArchived,
                    onEdit: ()=>onEditContact(contact.id),
                    onDelete: ()=>onDeleteContact(contact.id)
                }, contact.id);
            })
        });
    })();
    return /*#__PURE__*/ _jsx(SectionCard, {
        bi: {
            name: 'client_detail_contacts_card'
        },
        testId: TID.Root(),
        title: contactsTexts.title(),
        showActions: !isArchived,
        bodyClassName: styles.scrollableBody,
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_add_contact'
            },
            testId: TID.AddContactButton(),
            variant: "paragraph2",
            skin: "primary",
            weight: "normal",
            underline: "none",
            onClick: onAddContact,
            children: contactsTexts.addContact()
        }),
        children: content
    });
}
